const Panel = ({
  children,
  title,
}: {
  children: React.ReactNode
  title: string
}) => {
  return (
    <div className="pb-2 rounded-lg shadow-lg border border-theme-gray-200 dark:border-theme-gray-700 bg-theme-gray-50 dark:bg-theme-gray-900">
      <div className=" px-4 py-1  text-xl rounded-t-lg bg-theme-yellow dark:bg-theme-purple border-b border-theme-gray-200 dark:border-theme-gray-700">
        <h1>{title}</h1>
      </div>
      <div className=" px-4 bg-theme-gray-50 dark:bg-theme-gray-900">
        <div className="pt-4">{children}</div>
      </div>
    </div>
  )
}

export default Panel
